import React from 'react';

import { CampaignMediaColors, Maybe } from '../../types';

import * as S from './styles';

type OwnProps = {
  colors: Maybe<CampaignMediaColors> | undefined;
  className?: string;
  size?: 'small' | 'large';
};

const CampaignBadge = ({ colors, className, size = 'small' }: OwnProps) => {
  const width = size === 'small' ? 12 : 20;
  const height = size === 'small' ? 10 : 18;

  const icon = (
    <svg width={width} height={height} viewBox="0 0 15 13">
      <path
        d="M3.5 3.3c0-.555-.445-1-1-1-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1zm8.336 4.5c0 .266-.11.523-.29.703l-3.835 3.844c-.187.18-.444.29-.71.29-.266 0-.523-.11-.703-.29L.71 6.753C.314 6.363 0 5.605 0 5.05V1.8c0-.547.453-1 1-1h3.25c.555 0 1.313.312 1.71.71l5.587 5.58c.18.187.29.444.29.71zm3 0c0 .266-.11.523-.29.703l-3.835 3.844c-.187.18-.444.29-.71.29-.406 0-.61-.19-.875-.462l3.672-3.672c.18-.18.29-.437.29-.703 0-.266-.11-.523-.29-.71L7.21 1.51C6.814 1.113 6.056.8 5.5.8h1.75c.555 0 1.313.312 1.71.71l5.587 5.58c.18.187.29.444.29.71z"
        // @ts-ignore
        fill={colors?.text || '#FFF'}
        fillRule="evenodd"
      />
    </svg>
  );

  return (
    <S.CampaignBadge campaignStyling={colors} className={className} size={size}>
      {icon}
    </S.CampaignBadge>
  );
};

export default CampaignBadge;
